import {
  amountFromCents,
  emptyInstallment,
} from './realEstateCommissionPlanForm';

export const syncIntegralInstallment = ({ form, netCents }) => {
  if (form.modality !== 'integral') return form;

  return {
    ...form,
    installments: [
      {
        ...form.installments[0],
        amount: amountFromCents(Math.max(0, netCents)),
      },
    ],
  };
};

export const resizeInstallments = ({ form, count }) => {
  const desiredCount = Math.max(1, Number(count) || 1);
  return {
    ...form,
    installments: Array.from(
      { length: desiredCount },
      (_, index) => form.installments[index] || emptyInstallment()
    ),
  };
};
